export default __webpack_public_path__ + "static/media/img1.08d8b16b.jpg";